import React from 'react';
import './nodatafound.less';

const NoDataFound = () => {
  return (
    <div className="nodataFoundWrapper">
      <div className="npdataFoundInner">
        <img src={require('./nodata.jpg')} alt="" />
        <h2>No Data Found</h2>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
        <button className="commonButton">Diamond Search</button>
      </div>
    </div>
  );
};
export default NoDataFound;
